/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import _ from 'lodash';
import moment from 'moment';
// import { AvailableGaugePanels } from './panel-chart-const';

const DATE_RANGE_TYPES = Object.freeze({
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
});

export function initDateRangeRules({ dateRangeDatesDiff, dateRangeTypes, companyConfigViewBy }) {
  const sortedDateRangeTypes = Object.values(dateRangeTypes).sort((a, b) => a.duraion - b.duraion);

  for (const item of sortedDateRangeTypes) {
    if (dateRangeDatesDiff < item.duraion) {
      item.disabled = false;
      sortedDateRangeTypes
        .filter((otherItem) => otherItem.type != item.type)
        .map((otherItem) => {
          otherItem.disabled = otherItem.duraion > item.duraion;
        });
      break;
    }
  }

  let selectedDateRange = null;

  if (dateRangeTypes.day && !dateRangeTypes.day.disabled && companyConfigViewBy && companyConfigViewBy.dailyWithinDays && dateRangeDatesDiff <= companyConfigViewBy.dailyWithinDays) {
    selectedDateRange = DATE_RANGE_TYPES.DAY;
  } else if (dateRangeTypes.week && !dateRangeTypes.week.disabled && companyConfigViewBy && companyConfigViewBy.weeklyWithinDays && dateRangeDatesDiff <= companyConfigViewBy.weeklyWithinDays) {
    selectedDateRange = DATE_RANGE_TYPES.WEEK;
  } else if (dateRangeTypes.month && !dateRangeTypes.month.disabled && companyConfigViewBy && companyConfigViewBy.monthlyWithinDays && dateRangeDatesDiff <= companyConfigViewBy.monthlyWithinDays) {
    selectedDateRange = DATE_RANGE_TYPES.MONTH;
  } else if (
    dateRangeTypes.quarter &&
    !dateRangeTypes.quarter.disabled &&
    companyConfigViewBy &&
    companyConfigViewBy.quarterlyWithinDays &&
    dateRangeDatesDiff <= companyConfigViewBy.quarterlyWithinDays
  ) {
    selectedDateRange = DATE_RANGE_TYPES.QUARTER;
  } else if (dateRangeTypes.year && !dateRangeTypes.year.disabled && companyConfigViewBy && companyConfigViewBy.yearlyWithinDays && dateRangeDatesDiff <= companyConfigViewBy.yearlyWithinDays) {
    selectedDateRange = DATE_RANGE_TYPES.YEAR;
  } else {
    // get default date range type
    for (const item of sortedDateRangeTypes) {
      if (dateRangeDatesDiff < item.duraion) {
        selectedDateRange = item.type;
        break;
      }
    }
  }

  return selectedDateRange;
}

/**
 * @param: selectedDateRange: DATE_RANGE_TYPES
 * @param: metrics: Metric[]
 *
 * interface Metric {
 *  date: string // '2023-01-01'
 *  value: number // 50
 * }
 */

export function groupByDateRangeForVolume({ selectedDateRange, metrics }) {
  // const transformValue = (value) => _.sumBy(value, 'value').toFixed(0);
  const transformValue = (value) => (_.sumBy(value, 'value') > 0 ? _.sumBy(value, 'value').toFixed(0) : null);

  const groupedMetrics = _(metrics)
    .groupBy(selectedDateRange)
    .map((items, key) => ({ date: key, value: transformValue(items) }))
    .value();

  return groupedMetrics;
}

export function groupByDateRangeForAvgVolume({ selectedDateRange, metrics }) {
  const transformValue = (value) => {
    if(value.length > 1) {
      let hasNum = 0;
      let sumScore = 0;
      let sumConversations = 0;
      value.forEach(item => {
        if(item.value != null) {
          if(item.rawData.totalConversations > 0) {
            sumScore = sumScore + item.rawData.totalAutoEvalScore;
            sumConversations = sumConversations + item.rawData.totalConversations;
          }
          hasNum++
        }
      });
      return ((_.sumBy(value, 'value') >= 0) && hasNum > 0  ? (sumScore / sumConversations) : null);
    }
    else {
      return (_.sumBy(value, 'value') >= 0 ? _.sumBy(value, 'value') : null);
    }
  }

  const groupedMetrics = _(metrics)
    .groupBy(selectedDateRange)
    .map((items, key) => ({ date: key, value: transformValue(items) }))
    .value();
  return groupedMetrics;
}

export function groupByDateRangeForAvgVolumeWithOverAll({ selectedDateRange, metrics }) {
  const transformValue = (value) => {
    if(value.length > 1) {
      let hasNum = 0;
      let sumScore = 0;
      let sumConversations = 0;
      value.forEach(item => {
        if(item.valueOverall != null) {
          if(item.rawData.totalConversationsOverall > 0) {
            sumScore = sumScore + item.rawData.totalAutoEvalScoreOverall;
            sumConversations = sumConversations + item.rawData.totalConversationsOverall;
          }
          hasNum++
        }
      });
      return ((_.sumBy(value, 'value') >= 0) && hasNum > 0  ? (sumScore / sumConversations) : null);
    }
    else {
      return (_.sumBy(value, 'value') >= 0 ? _.sumBy(value, 'valueOverall') : null);
    }
  }
  const groupedMetrics = _(metrics)
    .groupBy(selectedDateRange)
    .map((items, key) => ({ date: key, value: transformValue(items) }))
    .value();
  return groupedMetrics;
}

export function groupByDateRangeForBesBasAC({ selectedDateRange, metrics }) {
  let groupedMetrics = null;
  // let scorefieldName = 'rawData.totalAutoEvalScore'//selectedPanel === AvailableGaugePanels.bes ? 'rawData.totalAutoEvalScore' : 'rawData.TotalBASScore';
  // let volumefieldName = 'rawData.averageAutoEvalScore' //selectedPanel === AvailableGaugePanels.bes ? 'rawData.averageAutoEvalScore' : 'rawData.basScoreVolume';
  const transformValueForBesBas = (value) => {
    // Math.round((_.sumBy(value, scorefieldName) / _.sumBy(value, volumefieldName)) * 100);
    return Math.round((_.sumBy(value, 'value' )));
  }

  // const transformValueForAc = (value) =>
  //   (_.sumBy(value, scorefieldName) / ((wysdomContractValue + customerResourceCosts) / 12 + thirdPartyBotPlatformFees * _.sumBy(value, volumefieldName))).toFixed(2);
  // const transformValueForAc = (items) =>
  //   ((wysdomContractValue + customerResourceCosts) * (items.length / 365) + (thirdPartyBotPlatformFees * _.sumBy(items, volumefieldName))) / _.sumBy(items, scorefieldName);

  // if (selectedPanel === AvailableGaugePanels.bas || selectedPanel === AvailableGaugePanels.bes) {
    groupedMetrics = _(metrics)
      .groupBy(selectedDateRange)
      .map((items, key) => ({ date: key, value: transformValueForBesBas(items) }))
      .value();
  // } 
  // else if (selectedPanel === AvailableGaugePanels.automated_chat) {
  //   const NO_DATA = -1;
  //   groupedMetrics = _(metrics)
  //     .groupBy(selectedDateRange)
  //     .map((items, key) => ({
  //       date: key,
  //       value: wysdomContractValue == NO_DATA && customerResourceCosts == NO_DATA && thirdPartyBotPlatformFees == NO_DATA ? null : transformValueForAc(items),
  //     }))
  //     .value();
  // }

  groupedMetrics = groupedMetrics.map((metric) => {
    if (isNaN(metric.value)) {
      return { ...metric, value: null };
    }
    return metric;
  });

  return groupedMetrics;
}

export function formatDateRangeForPlotly({ selectedDateRange, groupedMetrics, dateStart }) {
  let xValues = [];
  if (selectedDateRange === DATE_RANGE_TYPES.DAY) {
    xValues = groupedMetrics.map((metric) => metric.date);
  } else if (selectedDateRange === DATE_RANGE_TYPES.WEEK) {
    xValues = groupedMetrics.map((metric) => {
      const [year, week] = metric.date.split('-');
      // return dateStart, week interval
      return moment()
        .year(year)
        .week(week)
        .day(0)
        .format('YYYY-MM-DD');
    });

    // make sure the first date is the start date
    xValues[0] = dateStart;
  } else if (selectedDateRange === DATE_RANGE_TYPES.MONTH) {
    xValues = groupedMetrics.map((metric) => moment(metric.date).format('YYYY-MM'));
  } else if (selectedDateRange === DATE_RANGE_TYPES.YEAR) {
    xValues = groupedMetrics.map((metric) => moment(metric.date).format('YYYY'));
  }

  return xValues;
}
